import React from "react";
import { Button } from "react-bootstrap";
import "./index.scss";
const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  return (
    <div className=" pagination d-flex justify-content-between align-items-center mt-3 m-4">
      <p className="text-muted small mb-0">
        Showing {currentPage} of {totalPages}
      </p>
      <div className="pagination-wrapper d-flex gap-2 flex-wrap">
        <Button
          variant="light"
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}>
          {"<"}
        </Button>
        {[...Array(totalPages).keys()].map((p) => (
          <Button
            key={p}
            variant={currentPage === p + 1 ? "primary" : "light"}
            onClick={() => onPageChange(p + 1)}>
            {p + 1}
          </Button>
        ))}
        <Button
          variant="light"
          disabled={currentPage === totalPages}
          onClick={() => onPageChange(currentPage + 1)}>
          {">"}
        </Button>
      </div>
    </div>
  );
};

export default Pagination;
